import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { LegalPage } from './LegalPage';
const sections = [{
  title: '1. Introduction',
  content: '888 Sourcing Limited ("we", "us", "our") uses cookies and similar technologies on our website to enhance your experience, analyze site usage, and support our services. This Cookie Policy explains what cookies are, how we use them, and your choices regarding them.'
}, {
  title: '2. What Are Cookies?',
  content: 'Cookies are small text files placed on your device when you visit a website. They help the site remember information about your visit, such as preferences, login details, or analytics data.'
}, {
  title: '3. Types of Cookies We Use',
  content: ['Essential Cookies: Necessary for the operation of the website (e.g., security, login, or session management).', 'Performance & Analytics Cookies: Help us understand how visitors use the website and improve functionality.', 'Functional Cookies: Remember choices you make on the website (e.g., language preferences).', 'Advertising & Targeting Cookies: Used to deliver relevant content and ads.']
}, {
  title: '4. Third-Party Cookies',
  content: "We may use third-party services such as Google Analytics to track website usage and performance. These cookies are subject to the third party's privacy policies."
}, {
  title: '5. Managing Cookies',
  content: 'You can manage or disable cookies through your browser settings. Please note that disabling certain cookies may affect website functionality and user experience.'
}, {
  title: '6. Consent',
  content: 'By continuing to use our website, you consent to the use of cookies as described in this policy. You may withdraw consent at any time by adjusting your browser settings.'
}, {
  title: '7. Changes to This Policy',
  content: 'We may update this Cookie Policy from time to time. Any changes will be posted on this page with an updated effective date.'
}];
export function CookiePolicyPage() {
  useEffect(() => {
    document.title = 'Cookie Policy | 888 Sourcing Limited';
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-[#0a1628] text-white" data-id="element-599">
      <div className="container mx-auto px-4 py-8" data-id="element-600">
        <div className="flex items-center justify-between mb-8" data-id="element-601">
          <div className="flex items-center space-x-2" data-id="element-602">
            <Link to="/" className="flex items-center space-x-2" data-id="element-603">
              <ArrowLeft className="w-5 h-5" data-id="element-604" />
              <span className="text-lg font-semibold" data-id="element-605">Back to Home</span>
            </Link>
          </div>
          <h1 className="text-3xl font-bold" data-id="element-606">Cookie Policy</h1>
        </div>
        <LegalPage title="Cookie Policy" lastUpdated="January 2024" sections={sections} showContactInfo={true} data-id="element-607" />
      </div>
    </div>;
}